import { Street } from '../_classes/list/street';

export let Streets: Street[] = [
  {
    id: 1,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Ленина',
    socr: 'пр-кт',
    post: '454020',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1593'
  },
  {
    id: 2,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Давыдова',
    socr: 'пр-кт',
    post: '454077',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1594'
  },
  {
    id: 3,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Сталелитейная',
    socr: 'ул',
    post: '454023',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1595'
  },
  {
    id: 4,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Победы',
    socr: 'пр-кт',
    post: '454011',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1596'
  },
  {
    id: 5,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Доватора',
    socr: 'ул',
    post: '454017',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1597'
  },
  {
    id: 6,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Трубопрокатная',
    socr: 'ул',
    post: '454123',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1599'
  },
  {
    id: 7,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Свердловский',
    socr: 'пр-кт',
    post: '454089',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1518'
  },
  {
    id: 8,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Дружинная',
    socr: 'ул',
    post: '454217',
    nda: null,
    aoguid: '51f21baa-c804-4737-9d5f-9da7a3bb1528'
  }
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/streets.ts